import { Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import { AssociationAndDistrictSelect } from 'src/shared/components/organisms/associationAndDistrictSelect';
// import { ContentSection } from 'src/shared/components/organisms/contentSectxion';
import { useGlobals } from 'src/shared/contexts/appContext';
import { useStatisticsContext } from 'src/shared/contexts/statisticsContext';
import { SecondaryTitle } from 'src/shared/components/atoms/secondaryTitle';
import { ReportPicker } from '../components/reportPicker';

export const StatisticReportPage = () => {
  const { currentUser } = useGlobals();
  const { association, setAssociation, district, setDistrict } = useStatisticsContext();
  const { t } = useTranslation();

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        <MainContentHeader title={t('statistics:report.title')} />
      </Grid>
      <Grid
        item
        xs='auto'
        sx={{
          pt: 2,
          pl: 2,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          '& .MuiAutocomplete-inputRoot': {
            backgroundColor: 'white',
          },
        }}
      >
        {currentUser && (
          <AssociationAndDistrictSelect
            hideDistrict={currentUser?.districts.length === 0}
            association={association}
            district={district}
            associationCallback={(val) => setAssociation(val || undefined)}
            districtCallback={(val) => setDistrict(val || undefined)}
          />
        )}
      </Grid>

      <Grid item xs={12} display='flex' flexDirection='column'>
        <Paper sx={{}}>
          <SecondaryTitle title={t('statistics:report.members')} divider uppercase />
          <Grid p={2}>
            <ReportPicker />
          </Grid>
          {/* <ContentSection header={t('statistics:report.members')}>
          </ContentSection> */}
        </Paper>
      </Grid>
      {/* <Grid item xs={12} display='flex' flexDirection='column'>
        <Paper>
          <SecondaryTitle title={t('statistics:report.payments')} divider uppercase />
          <Grid p={2}>
            <Box sx={{}}>
              <Typography color='text.disabled' variant='body1' sx={{ fontStyle: 'italic' }}>
                {t('common:sideMenu.comingSoon')}
              </Typography>
            </Box>
          </Grid>
        </Paper>
      </Grid> */}
    </Grid>
  );
};
